var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-bar white"
  }, [_c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "status-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "voice-controls"
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enterMeter,
      "leave": _vm.leaveMeter
    }
  }, [(_vm.isRecording) ? _c('div', {
    staticClass: "ml-2 volume-meter"
  }, [_c('meter', {
    attrs: {
      "value": _vm.volume,
      "min": "0.0001",
      "low": "0.005",
      "optimum": "0.04",
      "high": "0.07",
      "max": "0.09"
    }
  })]) : _vm._e()])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df12d09"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusBar.vue
// module id = 182
// module chunks = 1